tapecalc = function() {
    var length = parseFloat(document.getElementById('polycalc-length').value);
    var sealType = parseFloat(document.getElementById('SealType').selectedOptions[0].value);
    let inches = 3.14;
    
    var multi = 1;
    var to_cm = document.getElementById('to_cm').checked;
     
    if(to_cm){
      length = length * 2.54;   
      inches = inches * 2.54; 
    }
  
    var poly_length = ((length + (inches * 2) )*sealType).toFixed(1);
    
    if(isNaN(poly_length)){
        poly_length = "_";
    }
  
    document.getElementById('result-length').innerHTML = poly_length;
  }
  
  function change_mesure(){
    if (document.getElementById('to_cm').checked) 
    {
      var mesure = document.querySelectorAll('.result__calc .mesure');
      mesure.forEach(function(m) { m.textContent="cm"; });
      var mesure = document.querySelectorAll('.calc__mesure');
      mesure.forEach(function(m) { m.textContent="cm"; });
      
    } else {
      var mesure = document.querySelectorAll('.result__calc .mesure');
      mesure.forEach(function(m) { m.textContent='"'; });  
      var mesure = document.querySelectorAll('.calc__mesure');
      mesure.forEach(function(m) { m.textContent="inches"; });
    }
    tapecalc();
  }